import React from 'react'

import {Grid, Row, Col} from 'react-flexbox-grid'
import {Link} from 'react-router'

import {Alert} from 'antd'

import AppDispatcher from 'AppDispatcher'
import {Login} from './Login.jsx'
import {Register} from './Register.jsx'
import {AuthStore, AuthConstants} from 'api/auth'
import {Notify, Box} from 'ui'

export class Authenticate extends React.Component {
   constructor(props, ctx) {
      super(props, ctx)

      this._notify = null
   }

   static get propTypes() {
      return {
         // react-router
         location: React.PropTypes.object.isRequired,
         route:    React.PropTypes.object.isRequired,
         router:   React.PropTypes.object.isRequired,
         redirect: React.PropTypes.bool
      }
   }

   componentWillMount() {
      this._notify = new Notify.Store()
   }

   componentDidMount() {
      const {location, redirect} = this.props

      if (false === redirect) {
         return
      }

      if (AuthStore.isAuthenticated) {
         if (location.state && location.state.nextPathname) {
            this.context.router.replace(location.state.nextPathname)
         } else {
            this.context.router.replace('/')
         }
      }

      // refresh on user:login
      this._token = AppDispatcher.register(action => {
         switch (action.actionType) {
            case AuthConstants.Actions.login:
               if (location.state && location.state.nextPathname) {
                  this.context.router.replace(location.state.nextPathname)
               } else {
                  this.context.router.replace('/dashboard')
               }

               break

            case AuthConstants.Actions.logout:
               this.context.router.replace('/auth')
               break

            default:
               break
         }
      })
   }

   componentwillUnmount() {
      if (this._token) {
         AppDispatcher.unregister(this._token)
      }

      this._notify = null
   }

   render() {
      let info = (
         <Box.Info>
            <p>
               You are using a beta product, it may not work as
               expected at all times but by giving us feedback we
               improve it over time!
            </p>

            <p>
               <em>
                  By logging in to the <strong>Tinymesh Cloud™</strong> you agree to
                  our terms of service.
               </em>
            </p>
         </Box.Info>
      )

      let register = 'register' === this.props.location.query.auth
      let {route, router, location} = this.props

      return (
         <div className="auth login">
            <div className="featured">

               <Grid>
                  <Row>
                     <Col xs={12} smOffset={2} mdOffset={3} sm={8} md={6}>
                        <Alert
                           type="error"
                           message="Authentication Error"
                           description="You are required to authenticate to access this resource"
                           showIcon
                        />

                        <Box show={!register}>
                           <Notify store={this._notify} />

                           <Box.Content>
                              <Login
                                 notify={this._notify}
                                 signupLink={{
                                    ...location,
                                    query: {...location.query, auth: 'register'}
                                 }}
                              />
                           </Box.Content>

                           {info}
                        </Box>

                        <Box show={register}>
                           <Notify store={this._notify} />

                           <Box.Content>
                              <Register
                                 router={router}
                                 notify={this._notify}
                                 loginLink={{
                                    ...location,
                                    query: {...location.query, auth: 'login'}
                                 }}
                              />

                           </Box.Content>

                           {info}
                        </Box>
                     </Col>
                  </Row>
               </Grid>
            </div>
         </div>
      )
   }
}

Authenticate.contextTypes = {
   router: React.PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// lib/bundle/auth/Authenticate.jsx